if (!window.FoxThemeSocialSharingInitialized) {
  window.FoxThemeSocialSharingInitialized = true;

  document.addEventListener('click', (event) => {
    const messengerLink = event.target.closest('[data-messenger-mobile-href][data-messenger-desktop-href]');
    if (messengerLink) {
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

      if (isMobileDevice) {
        messengerLink.href = messengerLink.dataset.messengerMobileHref;
        messengerLink.removeAttribute('target');
        messengerLink.removeAttribute('rel');
        return;
      }

      messengerLink.href = messengerLink.dataset.messengerDesktopHref;
      messengerLink.setAttribute('target', '_blank');
      messengerLink.setAttribute('rel', 'noopener noreferrer');
      return;
    }

    const nativeShareButton = event.target.closest('[data-native-share-url]');
    if (!nativeShareButton) return;

    event.preventDefault();

    const shareUrl = nativeShareButton.dataset.nativeShareUrl;
    const shareTitle = nativeShareButton.dataset.nativeShareTitle || document.title;
    const copiedText = nativeShareButton.dataset.nativeShareCopiedText || 'Link copied';
    const tooltip = nativeShareButton.querySelector('.tooltip');

    const updateTooltip = (text) => {
      if (!tooltip) return;

      const previousText = tooltip.textContent;
      tooltip.textContent = text;

      window.setTimeout(() => {
        tooltip.textContent = previousText;
      }, 2000);
    };

    if (navigator.share) {
      navigator
        .share({
          title: shareTitle,
          url: shareUrl,
        })
        .catch(() => {});
      return;
    }

    if (navigator.clipboard?.writeText) {
      navigator.clipboard
        .writeText(shareUrl)
        .then(() => {
          updateTooltip(copiedText);
        })
        .catch(() => {});
    }
  });
}
